import { ABSENCE_TYPES } from '../constants';

export default function isAbsenceEvent(event) {
  return event && ABSENCE_TYPES.includes(event.type);
}
